import type { SignInCredential, SignInResponse } from '@/@types/auth';
import endpointConfig from '@/configs/endpoint.config';
import ApiService from './ApiService';

export async function apiSignIn(data: SignInCredential) {
  return ApiService.fetchDataWithAxios<SignInResponse>({
    url: endpointConfig.signIn,
    method: 'post',
    data,
  });
}

export async function apiSignOut() {
  return ApiService.fetchDataWithAxios({
    url: endpointConfig.signOut,
    method: 'post',
  });
}
